import React, { useState, useEffect, useMemo } from "react";
import { Dialog, DialogTitle, DialogContent, Button, TextField, Box, Typography, Grid, IconButton } from "@mui/material";
import { Formik } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import { useDispatch } from "store";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import { RxCross2 } from "react-icons/rx";
import { useGetPortfolioSummaryQuery } from "store/slices/apis/portfolioSummarySlice";
import { useGetAllProjectsQuery } from "store/slices/apis/projectApiSlice";
import Select from "react-select";
import { useGetMasterDataQuery } from "store/slices/apis/masterConfigation";
// import { useUpdateFinancialMutation } from "store/slices/apis/financialSlice";
import { useUpdateRailMutation } from "store/slices/apis/railTrackerApiSlice";

const rightLabelStyle = {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#5F5F5F",
    fontFamily: "Outfit, sans-serif",
};

const rightTextStyle = {
    "& .MuiInputBase-input": {
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "100%",
        letterSpacing: "0.16px",
        color: "#0A0A0C",
        fontFamily: "Outfit, sans-serif",
    },
};

const labelTextStyle = {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#5F5F5F",
    fontFamily: "Outfit, sans-serif",
    mb: 1,
    mt: 1,
};

const EditRail = (props) => {
    const { open, handleClose, rowData, refetchCounts } = props;
    const { projectId: routeProjectId } = useParams();
    const dispatch = useDispatch();
    const module = "Rail"

    const { data: statusData } = useGetMasterDataQuery({ module: module, category: 'Status', ProjectId: routeProjectId });

    const statusOptions =
        statusData?.data
            ?.map((item) => ({
                label: item?.value,
                value: item?.value
            }))
            ?.sort((a, b) => a.label.localeCompare(b.label)) || [];

    const [projectType, setProjectType] = useState(localStorage.getItem("projectType") || "all")

    const { data, error, isLoading, isFetching: isProjectFething, refetch } = useGetAllProjectsQuery(projectType);
    const { data: portfolioData, isFetching: portfolioLoader, isError: portfolioError } = useGetPortfolioSummaryQuery();

    const projectData = data?.data || [];
    const filteredProjectData = projectData.filter((data) => data.active == true);

    const projectOptions = (filteredProjectData || []).map(p => ({
        value: p.projectId,
        label: p.projectName,
        projectType: p.projectType,
    }));

    const portfolioOptions = (portfolioData?.data || []).map(p => ({
        value: p.portfolioName,
        label: p.portfolioName,
        projectType: p.portFolioType,
    }));

    const portfolioSelectOptions = useMemo(
        () => [
            // { projectType: "all", label: "All Portfolio" },
            ...portfolioOptions,
        ],
        [portfolioOptions]
    );

    const handlePortfolioChange = (option, setFieldValue) => {
        let projectType = option?.projectType || "all";
        setProjectType(projectType);
        localStorage.setItem("projectType", projectType)
        setFieldValue("product", option?.value || "");
    };

    const [updateRail] = useUpdateRailMutation();

    const [initialFormData, setInitialFormData] = useState({
        component: "",
        status: "",
        partnerName: "",
        product: "",
        project: "",
        projectId: "",
    });

    useEffect(() => {
        if (rowData && open) {
            setInitialFormData({
                component: rowData.component || "",
                status: rowData.status || "",
                partnerName: rowData.partnerName || "",
                projectId: rowData?.projectID || "",
                product: rowData?.product || "",
                project: rowData?.project || ""
                // financialId: rowData.financialId || null,
            });
        }
    }, [rowData, open, routeProjectId]);

    const validationSchema = Yup.object({
        product: Yup.string().required("Product is required"),
        project: Yup.string().required("Project is required"),
        // component: Yup.string()
        //     .required("Component is required"),

        status: Yup.string().required("Status is required"),

        // partnerName: Yup.string()
        //     .required("Partner Name is required"),

    });

    const emptyGUID = "00000000-0000-0000-0000-000000000000";

    const handleSubmit = async (values, { setSubmitting }) => {
        const reqBody = {
            projectId: values?.projectId || "",
            railAssetId: rowData.railAssetId,
            product: values?.product,
            project: values?.project,
            component: values?.component,
            status: values?.status,
            partnerName: values?.partnerName,
        };

        // console.log("Update payload:", reqBody);

        try {

            const response = await updateRail({ body: reqBody }).unwrap();
            openNotification(response.message || "Updated successfully", "success");
            setSubmitting(false);
            if (refetchCounts) refetchCounts();
            handleClose();
        } catch (error) {
            openNotification(error?.error ?? "Something went wrong", "error");
            setSubmitting(false);
        }
    };

    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: { color: type },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    return (
        <>
            <Dialog
                open={open}
                fullWidth
                maxWidth="md"
                PaperProps={{
                    sx: {
                        borderTopLeftRadius: "5px",
                        borderTopRightRadius: "5px",
                        backgroundColor: "#FFFFFF",
                        width: "100%",
                        overflowX: "hidden",
                    },
                }}
                disableEscapeKeyDown
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose();
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        borderBottom: "1px solid #ddd",
                        backgroundColor: "#ECECEC",
                        pb: 2,
                        pt: 3,
                        width: "100%",
                    }}
                >
                    <Box>
                        <Typography
                            sx={{
                                fontWeight: 600,
                                fontSize: "27px",
                                lineHeight: "100%",
                                color: "#140F36",
                                fontFamily: "Outfit, sans-serif",
                            }}
                        >
                            Edit Rail
                        </Typography>
                    </Box>
                </DialogTitle>
                <DialogContent dividers>
                    <Formik
                        enableReinitialize={true}
                        initialValues={initialFormData}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                    >
                        {({ values, errors, touched, submitCount, handleChange, handleBlur, setFieldTouched, setFieldValue, handleSubmit, isSubmitting }) => (
                            <form onSubmit={handleSubmit}>
                                <Grid container spacing={2}>
                                    {routeProjectId == undefined &&
                                        <Grid size={{ xs: 12, md: 6 }}>
                                            <Typography sx={labelTextStyle}>
                                                Product
                                            </Typography>

                                            <Select
                                                name="product"
                                                options={portfolioSelectOptions}
                                                value={
                                                    portfolioSelectOptions.find(
                                                        (opt) => opt.value === values.product
                                                    ) || null
                                                }
                                                onChange={(option) => handlePortfolioChange(option, setFieldValue)}
                                                onBlur={() => setFieldTouched("product", true)}
                                                placeholder="Select Portfolio"
                                            />

                                            {(touched.product || submitCount > 0) && errors.product && (
                                                <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
                                                    {errors.product}
                                                </Typography>
                                            )}
                                        </Grid>
                                    }

                                    {routeProjectId == undefined &&
                                        <Grid size={{ xs: 12, md: 6 }}>
                                            <Typography sx={labelTextStyle}>
                                                Project
                                            </Typography>

                                            <Select
                                                name="project"
                                                options={[{ value: emptyGUID, label: "All Projects" }, ...projectOptions]}
                                                value={
                                                    [{ value: emptyGUID, label: "All Projects" }, ...projectOptions]
                                                        .find(opt => opt.value === values.projectId) || null
                                                }
                                                onChange={(option) => {
                                                    setFieldValue("projectId", option?.value);
                                                    setFieldValue("project", option?.label);
                                                }}
                                                onBlur={() => setFieldTouched("project", true)}
                                                placeholder="Select Project"
                                            />

                                            {(touched.project || submitCount > 0) && errors.project && (
                                                <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
                                                    {errors.project}
                                                </Typography>
                                            )}
                                        </Grid>
                                    }

                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Typography sx={labelTextStyle}>
                                            Component
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            name="component"
                                            value={values.component}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Enter Component"
                                            InputProps={{
                                                sx: {
                                                    height: "40px",
                                                    borderRadius: "8px",
                                                    backgroundColor: "#fff",
                                                    "& input::placeholder": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        lineHeight: "100%",
                                                        letterSpacing: "0.16px",
                                                        color: "#5F5F5F",
                                                        fontFamily: "Outfit, sans-serif",
                                                        opacity: 1,
                                                    },
                                                    "& input": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        lineHeight: "100%",
                                                        letterSpacing: "0.16px",
                                                        color: "#0A0A0C",
                                                        fontFamily: "Outfit, sans-serif",
                                                        "&:-webkit-autofill": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                        "&:-webkit-autofill:hover": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                        "&:-webkit-autofill:focus": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                    },
                                                },
                                            }}
                                        />
                                        {touched.component && errors.component && (
                                            <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                {errors.component}
                                            </Typography>
                                        )}
                                    </Grid>

                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Typography sx={labelTextStyle}>
                                            Status
                                        </Typography>
                                        <Select
                                            name="status"
                                            options={statusOptions}
                                            value={statusOptions.find(opt => opt.value === String(values.status)) || null}
                                            onChange={(option) => setFieldValue("status", option.value)}
                                            onBlur={() => setFieldTouched("status", true)}
                                            placeholder="Select Status"
                                            styles={{
                                                menuList: (provided) => ({
                                                    ...provided,
                                                    maxHeight: "150px",
                                                    overflowY: "auto",
                                                }),
                                            }}
                                        />
                                        {touched.status &&
                                            errors.status && (
                                                <Typography
                                                    sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}
                                                >
                                                    {errors.status}
                                                </Typography>
                                            )}
                                    </Grid>

                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Typography sx={labelTextStyle}>
                                            Partner Name
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            name="partnerName"
                                            step="any"
                                            value={values.partnerName}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Enter Partner"
                                            InputProps={{
                                                sx: {
                                                    height: "40px",
                                                    borderRadius: "8px",
                                                    backgroundColor: "#fff",
                                                    "& input::placeholder": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        lineHeight: "100%",
                                                        letterSpacing: "0.16px",
                                                        color: "#5F5F5F",
                                                        fontFamily: "Outfit, sans-serif",
                                                        opacity: 1,
                                                    },
                                                    "& input": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        lineHeight: "100%",
                                                        letterSpacing: "0.16px",
                                                        color: "#0A0A0C",
                                                        fontFamily: "Outfit, sans-serif",
                                                        "&:-webkit-autofill": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                        "&:-webkit-autofill:hover": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                        "&:-webkit-autofill:focus": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                    },
                                                },
                                            }}
                                        />
                                        {touched.partnerName && errors.partnerName && (
                                            <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                {errors.partnerName}
                                            </Typography>
                                        )}
                                    </Grid>

                                    {/* Action Buttons */}
                                    <Grid size={12} sx={{ mt: 1, mb: 2 }}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                                alignItems: "center",
                                                gap: 2,
                                                mt: 2,
                                            }}
                                        >
                                            <Button onClick={handleClose}
                                                sx={{
                                                    textTransform: "none",
                                                    color: "#F15744",
                                                    fontSize: "14px",
                                                    lineHeight: "100%",
                                                    fontFamily: "Outfit, sans-serif",
                                                    borderRadius: "25px",
                                                    fontWeight: 500,
                                                    px: "20px",
                                                    py: "15px",
                                                }}>
                                                Cancel
                                            </Button>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                disabled={isSubmitting}
                                                sx={{
                                                    backgroundColor: "#00344C",
                                                    borderRadius: "25px",
                                                    textTransform: "none",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    lineHeight: "100%",
                                                    fontFamily: "Outfit, sans-serif",
                                                    color: "#FFFFFF",
                                                    px: "20px",
                                                    py: "15px",
                                                    '&:disabled': {
                                                        backgroundColor: '#cccccc',
                                                    }
                                                }}
                                            >
                                                {isSubmitting ? "Updating..." : "Update"}
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </form>
                        )}
                    </Formik>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default EditRail;